// Adult Control Run state. localStorage-backed for now; will move server-side
// (per-step timestamps + actor) so runs are shared across staff/devices.

const KEY = "pioneer_run_adult";

export const TOTAL_STEPS = 7;

export interface RunState {
  step: number; // 1-7 = active step, 8 = complete (step > TOTAL_STEPS)
  stepCompletedAt: Record<number, string>;
  gateKathyConfirmed: boolean;
  gateWebsiteLiveAt: string | null;
  gateNoticesSentAt: string | null;
}

const DEFAULT: RunState = {
  step: 1,
  stepCompletedAt: {},
  gateKathyConfirmed: false,
  gateWebsiteLiveAt: null,
  gateNoticesSentAt: null,
};

export function loadRun(): RunState {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULT, ...JSON.parse(raw) };
  } catch {}
  return { ...DEFAULT };
}

export function saveRun(state: RunState): void {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function resetRun(): RunState {
  const fresh = { ...DEFAULT, stepCompletedAt: {} };
  saveRun(fresh);
  return fresh;
}

// Order matters: treatment areas are finalized and scheduled BEFORE the notification list is
// pulled. The spray schedule legitimately diverges from the disease positives — an area may be
// sprayed with no positive in its subgrid, an adjacent subgrid may be chosen because the
// positive's own was sprayed last week, or the trigger may be a WNV-positive human case rather
// than a pool. So the notification list is derived from the scheduled areas, not the positives.
export const PHASES = [
  { num: 1, title: "Get & Load Data", tool: "VectorSurv → Update Dashboards" },
  { num: 2, title: "Analyze Disease Positives", tool: "Disease Positive Analysis" },
  { num: 3, title: "Build & Schedule Treatment Areas", tool: "Treatment Area Builder" },
  { num: 4, title: "Pull Notification List", tool: "Spray Notifications → Kathy" },
  // No separate "Publish to AGOL" step: the builder writes to the persistent layer itself and
  // schedules from there. An area that failed to sync is repaired by re-saving it in the builder.
  { num: 5, title: "Go-Live & Notify", tool: "Website + Email" },
  { num: 6, title: "Field Prep — Routes & Devices", tool: "Spray routes → FieldSeeker → Mesa" },
  { num: 7, title: "Next-Day Reconcile", tool: "Website + AGOL Subgrids" },
];
